import React, { FC } from 'react';
import ArrowRightIcon from '../Icon/ArrowRightIcon';
import ArrowLeftIcon from '../Icon/ArrowLeftIcon';
import styled from 'styled-components';
import Dropdown, { Button as DropdownButton } from '../DropdownSelect';
import Button from '../ThemedButton';
import { range } from 'ramda';
import { EnumButtonSize, EnumTheme } from '../../constants/enums';
import { getYear, getMonth } from 'utils/date';

const StyledDropdown = styled(Dropdown)`
  width: 100%;
  ${DropdownButton} {
    border-radius: 10px;
  }
`;

const SmallButton = styled(Button)`
  padding: 0 6px;
`;

interface IHeaderProps {
  date: Date;
  changeYear: (year: number) => void;
  changeMonth: (month: number) => void;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  decreaseYear: () => void;
  increaseYear: () => void;
  prevYearButtonDisabled: boolean;
  nextYearButtonDisabled: boolean;
}

const HeaderWrapper = styled.div`
  display: grid;
  justify-content: space-between;
  grid-column-gap: 8px;
  grid-template-columns: auto 104px 80px auto;
  margin-bottom: 16px;
`;

const years = range(1990, getYear() + 1)
  .map(val => val.toString())
  .reverse();

const months = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

const Header: FC<IHeaderProps> = ({
  changeYear,
  changeMonth,
  date,
  decreaseMonth,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
  increaseMonth,
}) => {
  return (
    <HeaderWrapper>
      <SmallButton
        use={EnumTheme.borderWhite}
        size={EnumButtonSize.small}
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
      >
        <ArrowLeftIcon />
      </SmallButton>
      <StyledDropdown
        size={EnumButtonSize.small}
        use={EnumTheme.quaternary}
        list={months}
        selectedItem={getMonth(date)}
        onSelectDropdownItem={changeMonth}
        withChevron
      />
      <StyledDropdown
        size={EnumButtonSize.small}
        use={EnumTheme.quaternary}
        list={years}
        selectedItem={years.indexOf(getYear(date).toString())}
        onSelectDropdownItem={idx => {
          changeYear(Number(years[idx]));
        }}
        withChevron
      />
      <SmallButton
        use={EnumTheme.borderWhite}
        size={EnumButtonSize.small}
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
      >
        <ArrowRightIcon />
      </SmallButton>
    </HeaderWrapper>
  );
};

export default Header;
